<template>
  <div class="animated fadeIn">
    <AnalyteRangeFormSoil
      v-if="analyte.sample_type.name === 'Soil'"
      :analyte="analyte"
    />

    <AnalyteRangeFormTissue
      v-else-if="analyte.sample_type.name === 'Tissue'"
      :analyte="analyte"
    />

    <AnalyteRangeFormFeed
      v-if="analyte.sample_type.name === 'Feed'"
      :analyte="analyte"
    />

    <AnalyteRangeFormWater
      v-if="analyte.sample_type.name === 'Water'"
      :analyte="analyte"
    />
  </div>
</template>

<script>
import AnalyteRangeFormSoil from '@/components/lab/analyte/form/AnalyteRangeFormSoil'
import AnalyteRangeFormTissue from '@/components/lab/analyte/form/AnalyteRangeFormTissue'
import AnalyteRangeFormFeed from './form/AnalyteRangeFormFeed.vue'
import AnalyteRangeFormWater from './form/AnalyteRangeFormWater.vue'

export default {
  name: 'AnalyteRangeForm',
  components: {
    AnalyteRangeFormSoil,
    AnalyteRangeFormTissue,
    AnalyteRangeFormFeed,
    AnalyteRangeFormWater
  },
  props: {
    analyte: {
      type: Object,
      default: () => null
    }
  }
}
</script>
